import { render, staticRenderFns } from "./OrganisationLocations.vue?vue&type=template&id=7c857afa&scoped=true"
import script from "./OrganisationLocations.vue?vue&type=script&lang=ts"
export * from "./OrganisationLocations.vue?vue&type=script&lang=ts"
import style0 from "./OrganisationLocations.vue?vue&type=style&index=0&id=7c857afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c857afa",
  null
  
)

export default component.exports